/**
 * Cover Club reads books through the existing Bookshelf data model instead
 * of duplicating title/author/genre fields — this merges the user's own
 * shelf (SEED_BOOKS) with the wider discoverable catalog (DISCOVERABLE_BOOKS)
 * into one lookup so a CoverEntry can stay a thin { bookId, ... } reference.
 *
 * The catalog + getBookById/isBookOnShelf now live in lib/localBookCatalog.js
 * (Book Details needs the same lookup outside Cover Club) — re-exported here
 * so this feature's existing imports keep working unchanged.
 */

export { getBookById, isBookOnShelf } from '@/lib/localBookCatalog';

/**
 * Build a full Bookshelf-schema book object for a discoverable (not-yet-
 * shelved) book, mirroring AddBookModal's shape so addBook() behaves
 * identically whether the user adds a book from there or from Cover Club.
 */
export function toShelfBook(book, shelfId) {
  return {
    id: book.id,
    title: book.title,
    author: book.author,
    tone: book.tone,
    genres: book.genres,
    totalPages: book.totalPages,
    status: shelfId === 'shelf_tbr' ? 'tbr' : shelfId === 'shelf_reading' ? 'reading' : 'tbr',
    isFavorite: false,
    dateAdded: Date.now(),
  };
}
